import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as action from './lamina.action'
import * as blocoActions from '../bloco/bloco.action'
import * as commonActions from '@common/common.action'
import WebapiCommon from '../../../util/webapi.common'
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar'
import LaminaPage from './lamina.page'
import LaminaApi from './lamina.api'
import { acessoPermitido } from '../../../../../acessos.seguranca'
import * as acessos from '../../../../../acessos.const.util'
import IntlMessage from '../../../../../helpers/intlMessage'

class LaminaContainer extends Component {
  constructor (props) {
    super(props)
    this.laudoRef = React.createRef()
    this.state = {
      qtdLaminas: 0,
      complemento: '',
      complementos: [],
      laudo: this.props.laudo,
      nr_exame: this.props.nrExame,
      patologistas: [],
      patologista: null,
      tecnicos: [],
      tecnico:  {
        label: this.props.usuario.usuarioId + ' - ' + this.props.usuario.usuario,
        value: this.props.usuario.usuarioId
      },

      adicionarLamina: () => {
        this.adicionarLamina.bind(this)
      },
      toggleModalNaoConfor: () => {
        this.toggleModalNaoConfor.bind(this)
      },
      toggleModalCancelar: () => {
        this.toggleModalCancelar.bind(this)
      },
      apagarLaminaCongelacao: () => {
        this.apagarLaminaCongelacao.bind(this)
      },
      callBackConclusaoInclusaoResolucaoNConformidade: () => {
        this.callBackConclusaoInclusaoResolucaoNConformidade.bind(this)
      },
      preencherJustificativaParaCancelamento: () => {
        this.preencherJustificativaParaCancelamento.bind(this)
      },

      exame: '',
      paciente: '',
      prontuario: '',
      blocosCongelacoes: [],
      blocoCongelacao: null,
      laudoNaoExiste: true,
      dataInclusaoLamina: new Date().toISOString().slice(0, 10),
      naoconformidades: [],
      nConfInclusaoLamina: null,
      periodoInicial: null,
      periodoFinal: null,
      numeroDoExame: '',
      modalOpenNaoConfor: false,
      itemInModal: null,
      modalOpenCancelar: false,
      itemInModalCancelar: null,
      justificativaParaCancelamento: '',
      showModalImprimirEtiqueta: false,
      showModalImprimirEtiquetaEmLote: false,
      showModalDelegacaoLaminas: false,
      laminasParaEtiqueta: [],
      laminaIndividualParaEtiqueta: null,
      showModalJustificativa: false,
      justificativa: '',
      observacoes: '',
      laminaId: this.props.laminaId,
      modalConfirmarTitulo: <IntlMessage id = "dashboards.examDetail.headsUp"/>,
      modalConfirmarMensagem:
        'Existe(m) registro(s) de lançamento(s) de lâmina(s) para esse bloco. \n Este fato impede qualquer alteração desse registro. Verifique!',
      modalConfirmarType: 'ok', // confirm(default) | ok
      modalBloco: false,
      dsIdentificacaoLamina: '',
      nomeLamina: ''
    }
  }

  // selectionarTecnicoLogado (){
  //   const usuarioLogado = getUsuarioLocalStorage();
  //   const tecnico = props.tecnicos.find((tecnico) => tecnico.id === usuarioLogado.id);

  //   if(tecnico && tecnico[0]){
  //     props.tecnico = tecnico;
  //   }
  // }

  showModalAdicionarLamina () {
    let state = { ...this.state }

    this.props.actions.modalLamina(!this.props.modalLamina)

    state.qtdLaminas = 0
    state.complemento = ''
    state.patologista = null

    if (this.props.medicoPadrao !== null) {
      let encontrouMedico = state.patologistas.find(
        el => el.value === this.props.medicoPadrao
      )
      if (encontrouMedico) {
        state.patologista = encontrouMedico
      }
    }

    state.tecnico = {
      label: this.props.usuario.usuarioId + ' - ' + this.props.usuario.usuario,
      value: this.props.usuario.usuarioId
    }

    state.laudo = ''
    state.nr_exame = ''
    state.prontuario = ''
    state.paciente = ''
    state.exame = ''
    state.laudoNaoExiste = true
    state.blocosCongelacoes = []
    state.blocoCongelacao = null
    state.nConfInclusaoLamina = null

    this.setState(state)
  }

  alterarValorState (propName, valor) {
    let state = { ...this.state }
    state[propName] = valor
    this.setState(state)
  }

  adicionarLamina () {
    let {
      qtdLaminas,
      complemento,
      patologista,
      laudo,
      tecnico,
      nConfInclusaoLamina,
      blocoCongelacao,
      observacoes
    } = this.state

    let laminaRequest = {
      laudo: laudo,
      quantidade: qtdLaminas,
      complemento: complemento.label,
      idUsuarioLogado: this.props.usuario.usuarioId,
      idMedicoPatologista: null,
      idTecnico: null,
      nomeMedicoPatologista: '',
      nomeTecnico: '',
      idNConf: null,
      cdBloco: null,
      observacoes: observacoes
    }

    if (patologista) {
      laminaRequest.idMedicoPatologista = patologista.value
      laminaRequest.nomeMedicoPatologista = patologista.label
    }

    if (tecnico) {
      laminaRequest.idTecnico = tecnico.value
      laminaRequest.nomeTecnico = tecnico.label
    }

    if (nConfInclusaoLamina) {
      laminaRequest.idNConf = nConfInclusaoLamina.value
    }

    if (blocoCongelacao) {
      laminaRequest.cdBloco = blocoCongelacao.value
    }

    this.props.commonActions.showFadeCarregando(true)

    LaminaApi.adicionarLaminaCongelacao(laminaRequest)
      .then(res => {
        if (res.success) {
          this.showModalAdicionarLamina()
          this.props.commonActions.showAlerta(
            'sucesso',
            res.message,
            2000,
            res.message.length * 10 + 'px'
          )
          this.props.commonActions.showFadeCarregando(false)
          this.props.actions.carregarLaminas(true)
          this.props.actions.alterarTab('2')
        } else {
          this.props.commonActions.showFadeCarregando(false)
          this.props.commonActions.showAlerta(
            'erro',
            res.message,
            2000,
            res.message.length * 10 + 'px'
          )
        }
      })
      .catch(err => {
        console.log("erro ao adicionar laminas");
        console.log(err);
      })
  }

  toggleModalNaoConfor = () =>
    this.setState(state => ({
      modalOpenNaoConfor: !state.modalOpenNaoConfor
    }))

  toggleModalCancelar = () =>
    this.setState(state => ({
      modalOpenCancelar: !state.modalOpenCancelar,
      justificativaParaCancelamento: ''
    }))

  toggleModalBloco = () => {
    this.props.blocoActions.modalBloco(!this.props.modalBloco)
    this.setState({ edicao: false })
  }

  apagarLaminaCongelacao () {
    let state = { ...this.state }

    this.props.commonActions.showFadeCarregando(true)

    LaminaApi.apagarLaminaCongelacao(
      state.itemInModalCancelar.laudo,
      state.itemInModalCancelar.idExterno,
      state.justificativaParaCancelamento
    ).then(res => {
      if (res.success) {
        let tecnico = !!state.tecnicoSelecionado
          ? state.tecnicoSelecionado.value
          : null
        this.toggleModalCancelar()
        this.filtrar(
          tecnico,
          state.periodoInicial,
          state.periodoFinal,
          state.numeroDoExame,
          state.laudoPesquisa
        )
        this.props.commonActions.showAlerta(
          'sucesso',
          res.message,
          2000,
          res.message.length * 10 + 'px'
        )
      } else {
        this.props.commonActions.showFadeCarregando(false)
        this.props.commonActions.showAlerta(
          'erro',
          res.message,
          2000,
          res.message.length * 10 + 'px'
        )
      }
    })
  }

  callBackConclusaoInclusaoResolucaoNConformidade () {
    let state = { ...this.state }
    this.props.commonActions.showFadeCarregando(true)
    let tecnico = !!state.tecnicoSelecionado
      ? state.tecnicoSelecionado.value
      : null
    this.filtrar(
      tecnico,
      state.periodoInicial,
      state.periodoFinal,
      state.numeroDoExame,
      state.laudoPesquisa
    )
  }

  preencherJustificativaParaCancelamento = event =>
    this.setState({
      justificativaParaCancelamento: event.currentTarget.value
    })

  handleCreateSelectCreatable = value => {
    const etapa = 'CONGELACAO'
    this.props.commonActions.showFadeCarregando(true)
    WebapiCommon.cadastrarComplemento(etapa, value).then(() => {
      WebapiCommon.listarComplemento(etapa).then(res => {
        let state = { ...this.state }
        state.complementos = res
        state.complemento = res.find(el => el.label === value)
        this.setState(state)
        this.props.commonActions.showFadeCarregando(false)
      })
    })
  }

  sortJSON (arr, key, way) {
    return arr.sort((a, b) => {
      let x = a[key]
      let y = b[key]
      let result
      if (way === 'asc') {
        result = x < y ? -1 : x > y ? 1 : 0
      }
      if (way === 'desc') {
        result = x > y ? -1 : x < y ? 1 : 0
      }
      return result
    })
  }

  pesquisaNumExame (numeroExame) {
    this.props.commonActions.showFadeCarregando(true)
    LaminaApi.obterInfoLaudoNovaLaminaCongelacao(
      encodeURIComponent(numeroExame)
    ).then(res => {
      let result = res.data
      let state = { ...this.state }

      if (result !== null) {
        state.laudo = result.laudo
        state.laudoNaoExiste = false
        state.exame = result.exame
        state.paciente = result.paciente
        state.prontuario = result.prontuario

        if (result.blocosCongelacoes !== undefined) {
          const arrblocosCongelacoes = result.blocosCongelacoes.map(el => ({
            label: el.numeroBloco,
            value: el.idLaudoBloco
          }))

          const draftBlocosCongelacoes = this.sortJSON(
            arrblocosCongelacoes,
            'value',
            'asc'
          )

          state.blocosCongelacoes = draftBlocosCongelacoes

          const draftResultBlocosCongelacoes = this.sortJSON(
            result.blocosCongelacoes,
            'numeroBloco',
            'asc'
          )

          this.props.blocoActions.atualizarListagemBlocos(
            draftResultBlocosCongelacoes
          )
        }
      } else {
        state.exame = ''
        state.nr_exame = ''
        state.paciente = ''
        state.prontuario = ''
        state.blocosCongelacoes = []
        state.blocoCongelacao = null
        state.laudoNaoExiste = true
      }

      this.setState(state)
      this.props.commonActions.showFadeCarregando(false)
    })
  }

  limparCamposAdicionarLaminas = () => {
    this.setState({
      qtdLaminas: 0,
      complemento: '',
      patologista: null,
      tecnico: null,
      laudo: '',
      nr_exame: '',
      prontuario: '',
      paciente: '',
      exame: '',
      laudoNaoExiste: true,
      blocosCongelacao: [],
      blocoCongelacao: null,
      observacoes: ''
    })

    this.props.actions.alterarLaminaText('Adicionar lâmina')
    this.props.actions.alterarLaminaId(null)
    this.props.actions.alterarEdicao(false)
  }

  deletarItemListagemBlocos = id => {
    const blocos = this.state.blocosCongelacoes
    const blocoSelected = this.state.blocoCongelacao
    const lista = []
    blocos.map(bloco => {
      if (bloco.value !== id) {
        lista.push(bloco)
      }
      if (blocoSelected && blocoSelected.value === id) {
        this.setState({ blocoCongelacao: null })
      }
      return lista
    })
    this.setState({ blocosCongelacoes: lista })

    // Deletar listagem blocos Redux
  }

  modalConfirmarApagar = () => {
    const justificativa = this.state.justificativa
    if (justificativa) {
      try {
        this.props.commonActions.showFadeCarregando(true);
        LaminaApi.apagarBlocoCongelacao(
          this.props.laudo,
          this.props.blocoId,
          justificativa
        ).then(()=>{
          this.props.commonActions.showFadeCarregando(false);
          this.deletarItemListagemBlocos(this.props.blocoId)
          this.props.actions.modalJustificativa(!this.props.modalJustificativa)
          this.setState({ justificativa: '', showModalJustificativa: false })
        })
      } catch (error) {
        const message = `Houve um erro na Api ao tentar apagar o bloco ${this.props.blocoId}: ${error}`
        this.props.commonActions.showAlerta(
          'erro',
          message,
          2000,
          message.length * 10 + 'px'
        )
      }
    }
  }

  deletarBloco (bloco) {
    if (
      !acessoPermitido(this.props.usuario, acessos.ApagarBlocos) &&
      !acessoPermitido(
        this.props.usuario,
        acessos.ApagarBlocoseLaminasCongelacao
      )
    ) {
      const message = `Você não tem permissão para apagar este bloco.`
      this.props.commonActions.showAlerta(
        'erro',
        message,
        3000,
        message.length * 10 + 'px'
      )
      return
    }
    const existeLamina = this.props.listarLaminas.findIndex(
      lamina => lamina.idBloco === bloco
    )
    if (existeLamina >= 0) {
      this.props.blocoActions.modalConfirmar(true)
    } else {
      this.props.blocoActions.modalJustificativa(true)
      this.props.blocoActions.atualizablocoID(bloco)
    }
  }

  async apagarComplemento (id, str) {
    this.props.commonActions.showFadeCarregando(true)
    LaminaApi.apagarComplemento(id)
      .then(res => {
        this.props.commonActions.showAlerta(
          'sucesso',
          res.message,
          2000,
          res.message.length * 10 + 'px'
        )

        const lista = []
        const complementos = this.state.complementos
        complementos.map(complemento => {
          if (complemento.label.indexOf(str) < 0) {
            lista.push(complemento)
          }
          return lista
        })
        this.setState({ complementos: lista, complemento: '' })
        this.props.commonActions.showFadeCarregando(false)
      })
      .catch(err => {
        this.props.commonActions.showFadeCarregando(false)
      })
  }
  componentDidMount () {
    this.props.commonActions.showFadeCarregando(true)
    Promise.all([
      WebapiCommon.getUsuarioTecnicoDaHistologia(),
      WebapiCommon.getMedicos(),
      WebapiCommon.getNaoConformidades(),
      WebapiCommon.listarComplemento('CONGELACAO')
    ]).then(res => {
      let state = { ...this.state }
      state.tecnicos = res[0]
      state.patologistas = res[1]
      state.naoconformidades = res[2]
      state.complementos = res[3]

      this.setState(state)
    })
  }

  atualizaNRExame = nrExame => this.setState({ nr_exame: nrExame })
  atualizaEdicao = edicao => this.setState({ edicao: edicao })

  componentDidUpdate (props) {
    if (this.props.modalLamina && this.laudoRef.current) {
      this.laudoRef.current.focus()
      this.setState({ modalBloco: false })
    }

    if (
      props.nrExame &&
      props.modalBloco &&
      !props.modalLamina &&
      !this.state.modalBloco
    ) {
      this.setState({ modalBloco: true })
      return this.pesquisaNumExame(props.nrExame)
    }

    if (this.props.isEdicao && this.props.activeTab === '2') {
      this.props.actions.alterarEdicao(false)
      this.limparCamposAdicionarLaminas()
    }

    if (this.props.nrExame && this.props.nrExame !== this.state.nr_exame) {
      this.atualizaNRExame(this.props.nrExame)
      return this.pesquisaNumExame(this.props.nrExame)
    }

    if (this.props.laminaId && this.props.carregarEdicao) {
      const lamina = this.props.listarLaminas.find(
        lamina => lamina.idLaudoLamina === this.props.laminaId
      )

      const state = { ...this.state }
      const complemento = state.complementos.find(
        complemento =>
          complemento.label === lamina.dsComplemento &&
          complemento.label.length === lamina.dsComplemento.length
      )

      state.blocoCongelacao = lamina.bloco && {
        label: lamina.bloco,
        value: lamina.idBloco
      }
      state.qtdLaminas = 1
      state.complemento = complemento
      state.observacoes = lamina.observacoes
      state.laminaId = lamina.idLamina
      state.nConfInclusaoLamina = this.state.naoconformidades.find(
        nc => nc.value === lamina.idNConf
      )
      state.tecnico = {
        label: `${lamina.idTecnico} - ${lamina.nomeTecnico}`,
        value: lamina.idTecnico
      }
      state.patologista = {
        label: `${lamina.idMedico} - ${lamina.nomeMedico}`,
        value: lamina.idMedico
      }
      this.setState(state)
      this.props.actions.carregarEdicao(false)
      this.props.actions.alterarEdicao(true)
    }
  }

  toggleModalJustificativa () {
    this.props.actions.modalJustificativa(!this.props.modalJustificativa)
  }

  setJustificativa (texto) {
    this.setState({
      justificativa: texto
    })
  }
  alterarObservacoes (texto) {
    this.setState({
      observacoes: texto
    })
  }

  editarLaminaId () {
    const payload = {
      idLaudoLamina: this.props.laminaId,
      idLamina: this.state.laminaId,
      laudo: this.props.laudo,
      complemento: !this.state.complemento ? '' : this.state.complemento.label,
      idTecnico: !this.state.tecnico ? 0 : this.state.tecnico.value,
      nomeTecnico: !this.state.tecnico ? '' : this.state.tecnico.label,
      idMedicoPatologista: !this.state.patologista
        ? 0
        : this.state.patologista.value,
      nomeMedicoPatologista: !this.state.patologista
        ? ''
        : this.state.patologista.label,
      idUsuarioLogado: this.props.usuario.usuarioId,
      idNConf: !this.state.nConfInclusaoLamina
        ? 0
        : this.state.nConfInclusaoLamina.value,
      observacoes: this.state.observacoes
    }

    this.props.actions.alterarEdicao(false)

    const state = { ...this.state }

    this.props.commonActions.showFadeCarregando(true);
    LaminaApi.editarLaminaCongelacao(payload)
      .then(res => {
        this.props.commonActions.showFadeCarregando(false);
        this.props.commonActions.showAlerta(
          'sucesso',
          res.message,
          2000,
          res.message.length * 10 + 'px'
        )

        state.dsIdentificacaoLamina = res.data.dsIdentificacaoLamina
        state.nomeLamina = res.data.lamina

        this.setState({
          dsIdentificacaoLamina: res.data.dsIdentificacaoLamina,
          nomeLamina: res.data.lamina
        })

        this.pesquisarLaminaAtualizar(state, this.props.laminaId)
        this.limparCamposAdicionarLaminas()
        this.props.actions.alterarTab('2')
      })
      .catch(() => {})
  }

  pesquisarLaminaAtualizar (dados, id) {
    const novaLista = this.props.listarLaminas.map(lamina => {
      if (lamina.idLaudoLamina === id) {
        lamina.dsComplemento = !dados.complemento
          ? null
          : dados.complemento.label
        lamina.dsIdentificacaoLamina = dados.dsIdentificacaoLamina
        lamina.idMedico = dados.patologista.value
        lamina.idNConf = dados.nConfInclusaoLamina
        lamina.idTecnico = dados.tecnico.value
        lamina.lamina = dados.nomeLamina
        lamina.naoConformidade = dados.nConfInclusaoLamina
        lamina.observacoes = dados.observacoes
        //lamina.nomeMedico = dados.patologista.label
        //lamina.nomeTecnico = dados.tecnico.label
      }
      return lamina
    })
    novaLista && this.props.actions.atualizarListagemLaminas(novaLista)
  }

  render () {
    return (
      <React.Fragment>
        <ModalConfirmar
          toggleModalConfirmar={() =>
            this.props.blocoActions.modalConfirmar(!this.props.modalConfirmar)
          }
          type={this.state.modalConfirmarType}
          showModalConfirmar={this.props.modalConfirmar}
          titulo={this.state.modalConfirmarTitulo}
          mensagem={this.state.modalConfirmarMensagem}
          confirmar={() =>
            this.props.blocoActions.modalConfirmar(!this.props.modalConfirmar)
          }
        />
        <LaminaPage
          usuario={this.props.usuario}
          acessoPermitido={acessoPermitido}
          laminaText={this.props.laminaText}
          laminaId={this.props.laminaId}
          // Justificativa - Inicio
          showModalJustificativa={this.props.modalJustificativa}
          toggleModalJustificativa={this.toggleModalJustificativa.bind(this)}
          setJustificativa={this.setJustificativa.bind(this)}
          justificativa={this.state.justificativa}
          modalConfirmarApagar={this.modalConfirmarApagar.bind(this)}
          // Justificativa - Fim
          observacoes={this.state.observacoes}
          alterarObservacoes={this.alterarObservacoes.bind(this)}
          open={this.props.modalLamina}
          toggle={this.showModalAdicionarLamina.bind(this)}
          openModalBloco={this.props.modalBloco}
          toggleModalBloco={this.toggleModalBloco.bind(this)}
          qtdLaminas={this.state.qtdLaminas}
          complemento={this.state.complemento}
          complementos={this.state.complementos}
          laudo={this.state.laudo}
          nr_exame={this.props.nrExame}
          patologistas={this.state.patologistas}
          patologista={this.state.patologista}
          tecnicos={this.state.tecnicos}
          tecnico={this.state.tecnico}
          alterarValorState={this.alterarValorState.bind(this)}
          adicionarLamina={this.adicionarLamina.bind(this)}
          editarLaminaId={this.editarLaminaId.bind(this)}
          handleCreateSelectCreatable={this.handleCreateSelectCreatable.bind(
            this
          )}
          exame={this.state.exame}
          paciente={this.state.paciente}
          prontuario={this.state.prontuario}
          blocosCongelacao={this.state.blocosCongelacoes}
          blocoCongelacao={this.state.blocoCongelacao}
          laudoNaoExiste={this.state.laudoNaoExiste}
          dataInclusaoLamina={this.state.dataInclusaoLamina}
          naoconformidades={this.state.naoconformidades}
          nConfInclusaoLamina={this.state.nConfInclusaoLamina}
          laudoRef={this.laudoRef}
          pesquisaNumExame={this.pesquisaNumExame.bind(this)}
          limparCamposAdicionarLaminas={this.limparCamposAdicionarLaminas.bind(
            this
          )}
          deletarBloco={this.deletarBloco.bind(this)}
          apagarComplemento={this.apagarComplemento.bind(this)}
          isEdicao={this.props.isEdicao}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    usuario: state.usuario,
    modalJustificativa: state.laminaCongelacao.modalJustificativa,
    blocoId: state.blocoCongelacao.blocoId,
    modalBloco: state.blocoCongelacao.modalBloco,
    modalConfirmar: state.blocoCongelacao.modalConfirmar,
    modalLamina: state.laminaCongelacao.modalLamina,
    listarLaminas: state.laminaCongelacao.listarLaminas,
    laminaText: state.laminaCongelacao.laminaText,
    laminaId: state.laminaCongelacao.laminaId,
    isEdicao: state.laminaCongelacao.isEdicao,
    carregarEdicao: state.laminaCongelacao.carregarEdicao,
    activeTab: state.laminaCongelacao.activeTab
  }
}

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(action, dispatch),
    blocoActions: bindActionCreators(blocoActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LaminaContainer)



// WEBPACK FOOTER //
// ./src/app/common/requisicaoCongelacao/tabs/lamina/lamina.container.js